import Phaser from 'phaser';
import Board from './board';
import Intro from './intro';
import { language } from './language';
import { CST } from '../CST';
import EndScreen from './end-screen';
import { Browser } from '@capacitor/browser';

var clickSound;

export default class Menu extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.MENU);
	}

	preload() {
		this.load.image('bg_menu', 'assets/english/landing-screen.png');
		this.load.image('btn_play', 'assets/english/start.png');
		this.load.image('btn_rules', 'assets/english/rules.png');
		this.load.image('btn-terms', 'assets/btn-terms.png');
	}

	create(data) {
		clickSound = this.sound.add('clickSound');

		this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'bg_menu' + language);

		this.play = this.add
			.image(
				this.cameras.main.width / 2 + 350,
				this.cameras.main.height / 2 + 150,
				'btn_play' + language,
			)
			.setScale(1)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerdown', () => {
				clickSound.play();
				this.scene.start(CST.SCENES.CATEGORYSELECTION, {
					scene: CST.SCENES.MENU,
					language: language,
				});

				// this.scene.start(CST.SCENES.TIME, {
				//   scene: CST.SCENES.MENU,
				//   language: language,
				// });
			});

		this.rules = this.add
			.image(
				this.cameras.main.width / 2 + 350,
				this.cameras.main.height / 2 + 265,
				'btn_rules' + language,
			)
			.setScale(1)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerdown', () => {
				clickSound.play();
				this.scene.pause();
				this.scene.launch(CST.SCENES.RULES1, {
					language: data.language,
					scene: CST.SCENES.MENU,
				});
			});

		this.btnTerms = this.add
			.image(
				this.cameras.main.width / 2 + 350,
				this.cameras.main.height / 2 + 380,
				'btn-terms' + language,
			)
			.setScale(1)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerdown', () => {
				clickSound.play();
				// Handle PDF button click event
				window.open('assets/Terms.pdf', '_blank');
			});

		// this.testimonial = this.add
		//   .image(
		//     this.cameras.main.width / 2 - 190,
		//     this.cameras.main.height / 2 + 290,
		//     "btn_testimonial"
		//   )
		//   .setScale(1.2)
		//   .setInteractive({
		//     useHandCursor: true,
		//   })
		//   .on("pointerup", () => {
		//     clickSound.play();
		//     if (/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
		//       Browser.open({
		//         url: "https://focusgames.com/videos/Recharge-Intro-The-Inside-Edition.m4v",
		//       });
		//     } else {
		//       window.open(
		//         "https://focusgames.com/videos/Recharge%20Intro%20The%20Inside%20Edition.mp4",

		//         "_blank"
		//       );
		//     }
		//   });

		// this.back = this.add
		//   .image(90, this.cameras.main.height / 2 + 410, "back_btn")
		//   .setScale(1.2)
		//   .setInteractive({
		//     useHandCursor: true,
		//   })
		//   .on("pointerdown", () => {
		//     clickSound.play();
		//     this.scene.start(CST.SCENES.LANGUAGE);
		//   });

		// Background-preload heavy game assets while user is at the menu
		for (let i = 1; i <= 28; i++) {
			this.load.image('scenario' + i, 'assets/english/cards/scenario (' + i + ').png');
			this.load.image(
				'zoom-scenario' + i,
				'assets/english/cards/eng-expanded/cardZoom-scenario (' + i + ').png',
			);
			this.load.image('feedback' + i, 'assets/english/cards/feedback (' + i + ').png');
			this.load.image(
				'zoom-feedback' + i,
				'assets/english/cards/eng-expanded/cardZoom-feedback (' + i + ').png',
			);
			this.load.image(
				'preview-scenario-' + i,
				'assets/english/preview/scenario-setup (' + i + ').png',
			);
			this.load.image(
				'preview-feedback-' + i,
				'assets/english/preview/feedback-setup (' + i + ').png',
			);
		}
		this.load.spritesheet({
			key: 'cardFlipScenario',
			url: 'assets/card-flip-scenario.png',
			frameConfig: { frameWidth: 758.68, frameHeight: 794 },
		});
		this.load.spritesheet({
			key: 'cardFlipFeedback',
			url: 'assets/card-flip-feedback.png',
			frameConfig: { frameWidth: 758.68, frameHeight: 794 },
		});
		this.load.spritesheet({
			key: 'roulette-sprite',
			url: 'assets/english/roulette.png',
			frameConfig: { frameWidth: 751.67, frameHeight: 813 },
		});
		this.load.spritesheet({
			key: '2min-sprite',
			url: 'assets/english/2min.png',
			frameConfig: { frameWidth: 94.5, frameHeight: 51 },
		});
		this.load.spritesheet({
			key: '5min-sprite',
			url: 'assets/english/5min.png',
			frameConfig: { frameWidth: 94.5, frameHeight: 51 },
		});
		this.load.spritesheet({
			key: '7min-sprite',
			url: 'assets/english/7min.png',
			frameConfig: { frameWidth: 94.5, frameHeight: 51 },
		});
		this.load.spritesheet({
			key: '10min-sprite',
			url: 'assets/english/10min.png',
			frameConfig: { frameWidth: 94.5, frameHeight: 51 },
		});
		this.load.image('bg', 'assets/english/bg.png');
		this.load.image('clock', 'assets/english/clock.png');
		this.load.image('overlay', 'assets/english/overlay.png');
		this.load.image('black_bg', 'assets/english/black_screen.png');
		this.load.image('backCardScenario', 'assets/english/scenario-card-back.png');
		this.load.image('backCardFeedback', 'assets/english/feedback-card-back.png');
		this.load.image('rules_btn', 'assets/english/rules-game.png');
		this.load.image('home_btn', 'assets/english/home.png');
		this.load.image('end_game_btn', 'assets/english/end-game.png');
		this.load.image('show-feedback-btn', 'assets/english/show-feedback-btn.png');
		this.load.image('next_btn', 'assets/english/go-forward.png');
		this.load.image('appreciate_btn', 'assets/english/appreciate.png');
		this.load.image('appreciate-small_btn', 'assets/english/appreciate-small.png');
		this.load.image('close_btn', 'assets/english/close.png');
		this.load.image('5minLeft', 'assets/english/5minLeft.png');
		this.load.image('2minLeft', 'assets/english/2minLeft.png');
		this.load.image('game_over', 'assets/english/game_over.png');
		this.load.image('times_up', 'assets/english/times-up.png');
		this.load.image('popup-facilitator-tab', 'assets/popup-facilitator-tab.png');
		this.load.image('popup-player-tab', 'assets/popup-player-tab.png');
		this.load.image('bg-end-game', 'assets/english/bg-end-game.png');
		this.load.image('home_btn', 'assets/english/home.png');
		this.load.image('replay_btn', 'assets/english/replay.png');
		this.load.image('affirmation-card', 'assets/english/end-cards/affirmation-card.png');
		this.load.image('prayer-card', 'assets/english/end-cards/prayer-card.png');
		this.load.image('trophy-card', 'assets/english/end-cards/trophy-card.png');
		this.load.image('zoom-affirmation-card', 'assets/english/end-cards/zoom-affirmation-card.png');
		this.load.image('zoom-prayer-card', 'assets/english/end-cards/zoom-prayer-card.png');
		this.load.image('zoom-trophy-card', 'assets/english/end-cards/zoom-trophy-card.png');
		this.load.image('affirmation-back', 'assets/english/end-cards/affirmation-back.png');
		this.load.image('prayer-back', 'assets/english/end-cards/prayer-back.png');
		this.load.image('trophy-back', 'assets/english/end-cards/trophy-back.png');
		this.load.spritesheet({
			key: 'affirmation-card-sprite',
			url: 'assets/english/end-cards/affirmation-card-sprite.png',
			frameConfig: { frameWidth: 643.8, frameHeight: 814 },
		});
		this.load.spritesheet({
			key: 'affirmation-back-sprite',
			url: 'assets/english/end-cards/affirmation-back-sprite.png',
			frameConfig: { frameWidth: 643.8, frameHeight: 814 },
		});
		this.load.spritesheet({
			key: 'prayer-card-sprite',
			url: 'assets/english/end-cards/prayer-card-sprite.png',
			frameConfig: { frameWidth: 643.8, frameHeight: 814 },
		});
		this.load.spritesheet({
			key: 'prayer-back-sprite',
			url: 'assets/english/end-cards/prayer-back-sprite.png',
			frameConfig: { frameWidth: 643.8, frameHeight: 814 },
		});
		this.load.spritesheet({
			key: 'trophy-card-sprite',
			url: 'assets/english/end-cards/trophy-card-sprite.png',
			frameConfig: { frameWidth: 643.8, frameHeight: 814 },
		});
		this.load.spritesheet({
			key: 'trophy-back-sprite',
			url: 'assets/english/end-cards/trophy-back-sprite.png',
			frameConfig: { frameWidth: 643.8, frameHeight: 814 },
		});
		this.load.spritesheet({
			key: 'firework-blue',
			url: 'assets/firework-blue.png',
			frameConfig: { frameWidth: 384.03, frameHeight: 385 },
		});
		this.load.spritesheet({
			key: 'firework-red',
			url: 'assets/firework-red.png',
			frameConfig: { frameWidth: 384.03, frameHeight: 385 },
		});
		this.load.spritesheet({
			key: 'firework-yellow',
			url: 'assets/firework-yellow.png',
			frameConfig: { frameWidth: 384.03, frameHeight: 385 },
		});
		this.load.image('bg-select-q', 'assets/bg-select-q.png');
		this.load.image('box-scenario', 'assets/preview-scenario.png');
		this.load.image('box-feedback', 'assets/preview-feedback.png');
		this.load.image('tab-scenario', 'assets/preview-scenario-tab.png');
		this.load.image('tab-feedback', 'assets/preview-feedback-tab.png');
		this.load.image('tick', 'assets/tick.png');
		this.load.image('confirm', 'assets/confirm.png');
		this.load.image('select-scenario', 'assets/select-scenario.png');
		this.load.image('unselect-scenario', 'assets/unselect-scenario.png');
		this.load.image('popup-select-scenario', 'assets/popup-select-scenario.png');
		this.load.image('clear', 'assets/clear-btn.png');
		this.load.image('popup-intro', 'assets/popup-intro.png');
		this.load.image('btn-next', 'assets/btn-next.png');
		this.load.image('popup-confirm-selection', 'assets/popup-confirm-selection.png');
		this.load.spritesheet({
			key: 'select-all-sprite',
			url: 'assets/english/select-all-btn.png',
			frameConfig: { frameWidth: 239.5, frameHeight: 50 },
		});
		this.load.start();

		if (data.scene === CST.SCENES.BOARD || data.scene === CST.SCENES.ENDSCREEN) {
			this.scene.remove(CST.SCENES.INTRO);
			this.scene.add(CST.SCENES.INTRO, Intro, false);
			this.scene.remove(CST.SCENES.BOARD);
			this.scene.add(CST.SCENES.BOARD, Board, false);
			this.scene.remove(CST.SCENES.ENDSCREEN);
			this.scene.add(CST.SCENES.ENDSCREEN, EndScreen, false);
		}

		this.events.on('start', () => {
			this.scene.remove(CST.SCENES.INTRO);
			this.scene.add(CST.SCENES.INTRO, Intro, false);
			this.scene.remove(CST.SCENES.BOARD);
			this.scene.add(CST.SCENES.BOARD, Board, false);
			this.scene.remove(CST.SCENES.ENDSCREEN);
			this.scene.add(CST.SCENES.ENDSCREEN, EndScreen, false);
		});
	}
}
